import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { catchError, map, mergeMap, throwError } from 'rxjs';
import { Interaction } from 'src/app/modules/entities/interaction';
import { Person } from 'src/app/modules/entities/person';
import { InteractionService } from 'src/app/modules/services/interaction.service';
import { PersonService } from 'src/app/modules/services/person.service';
import { errorDescription, url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-interaction-statistics',
  templateUrl: './interaction-statistics.component.html',
  styleUrls: ['./interaction-statistics.component.css']
})
export class InteractionStatisticsComponent implements OnInit {

  constructor(private router: Router, private interactionService: InteractionService, private messageService: MessageService,
    private personService: PersonService
  ) { }

  fullInteractionList: Interaction[] = [];
  fullPersonList: Person[] = [];
  interactionTypes: string[] = ['profile_view', 'whatsapp', 'phone'];
  selectedType: string = '';
  data: any;
  options: any;
  showChart: boolean = false;
  totalInteractions: number = 0;
  loading: boolean = false;

  ngOnInit(): void {
    this.interactionService.getAllInteractions()
      .pipe(
        mergeMap(interactionResponse$ => this.personService.getPersonListAdmin(false)
          .pipe(
            map(personResponse$ => {
              if (interactionResponse$ && interactionResponse$.status === 'success') {
                this.fullInteractionList = (interactionResponse$.data as Interaction[]);
                this.totalInteractions = interactionResponse$.size;
              }
              if (personResponse$ && personResponse$.status === 'success') {
                this.fullPersonList = personResponse$.data as Person[];
              }
              let personMap: { [key: number]: Person } = {};
              for (let person of this.fullPersonList) {
                personMap[person.idperson] = person;
              }
              for (let interaction of this.fullInteractionList) {
                interaction.person = personMap[Number(interaction.person as string)];
              }
            })
          )),
        catchError(err => { return throwError(() => err) })
      ).subscribe({
        error: error => {
          this.messageService.add({ severity: 'error', detail: errorDescription[error.error.error] });
          this.router.navigate([url['login']]);
        }
      });
  }

  loadChart() {
    this.loading = true;
    this.interactionService.getAllInteractionsQuantities().subscribe({
      next: response => {
        if (response.status === 'success') {
          this.fullPersonList.sort((a, b) => new Date(a.user.registrationDate) >= new Date(b.user.registrationDate) ? -1 : 1);
          let labels: string[] = [];
          let dataRaw: { [key: string]: number[] } = { 'profile_view': [], 'whatsapp': [], 'phone': [] }
          for (let person of this.fullPersonList) {
            labels.push(person.url_id);
            let statistics: {
              "url_id": string;
              "profile_view": number;
              "whatsapp": number;
              "phone": number;
            } = response.data.find(x => x.url_id === person.url_id)!;
            if (statistics) {
              dataRaw['profile_view'].push(statistics['profile_view']);
              dataRaw['whatsapp'].push(statistics['whatsapp']);
              dataRaw['phone'].push(statistics['phone']);
            }
          }
          this.data = {
            labels: labels,
            datasets: [
              {
                type: 'bar',
                label: 'Vistas de perfil',
                backgroundColor: '#ed1c23',
                data: dataRaw['profile_view']
              },
              {
                type: 'bar',
                label: 'Intentos de Whatsapp',
                backgroundColor: '#25d366',
                data: dataRaw['whatsapp']
              },
              {
                type: 'bar',
                label: 'Intentos de llamada',
                backgroundColor: '#003ea1',
                data: dataRaw['phone']
              }
            ]
          }
          this.options = {
            indexAxis: 'y',
            scales: {
              x: {
                stacked: true
              },
              y: {
                stacked: true
              }
            }
          }
          this.showChart = true;
          this.loading = false;
        }
      },
      error: error => {
        this.messageService.add({ severity: 'error', detail: errorDescription[error.error.error] });
        this.router.navigate([url['login']]);
      }
    });
  }

  getUrlProfile(urlId: string) {
    return '/' + url['perfil'] + '/' + urlId;
  }
}